export const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

export const pageview = (url) => {
  if (!GA_ID || !window.gtag) return;
  window.gtag('config', GA_ID, {
    page_path: url,
  });
};

export const event = ({ action, category, label, value }) => {
  if (!GA_ID || !window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  });
};
